import { c as _c } from "react/compiler-runtime";
import SeoHead from "@/components/seo/SeoHead";
import Link from "next/link";
import { breadcrumbJsonLd, seoForEvent } from "@/lib/seo";
import { ArrowLeft, Calendar, MapPin, Tag } from "lucide-react";
import { archivalEventsData, getArchivalEvent } from "@/data/archivalEventsData";
import EventCardMedia from "@/components/events/EventCardMedia";
import EventGallery from "@/components/events/EventGallery";
export default function ArchivalEventPage(t0) {
  const $ = _c(59);
  const {
    event
  } = t0;
  if (!event) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="min-h-screen bg-[#F4EFE6] flex items-center justify-center px-6"><div className="text-center"><h1 className="font-display text-[32px] sm:text-[40px] text-[#0F1C2E] mb-4">Event Not Found</h1><Link href="/events" className="font-body text-[#DF6D2A] underline hover:text-[#0F1C2E] transition-colors">Return to Events</Link></div></div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[1] !== event) {
    let t6;
    if ($[7] !== event.region || $[8] !== event.slug) {
      t6 = e => e.slug !== event.slug && e.region === event.region;
      $[7] = event.region;
      $[8] = event.slug;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    const sameRegion = archivalEventsData.filter(t6);
    const relatedEvents = (sameRegion.length >= 3 ? sameRegion : [...sameRegion, ...archivalEventsData.filter(e_0 => e_0.slug !== event.slug && e_0.region !== event.region)]).slice(0, 3);
    const t7 = seoForEvent(event);
    let t8;
    if ($[10] !== event.slug || $[11] !== event.title) {
      t8 = breadcrumbJsonLd([{
        name: "Home",
        path: "/"
      }, {
        name: "Events",
        path: "/events"
      }, {
        name: event.title,
        path: `/events/${event.slug}`
      }]);
      $[10] = event.slug;
      $[11] = event.title;
      $[12] = t8;
    } else {
      t8 = $[12];
    }
    if ($[13] !== t7 || $[14] !== t8) {
      t5 = <SeoHead {...t7} jsonLd={t8} />;
      $[13] = t7;
      $[14] = t8;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    t1 = "min-h-screen bg-[#F4EFE6]";
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <section className="bg-[#EBE5D9] border-b border-[#0F1C2E]/10 py-4 sm:py-6"><div className="max-w-[1100px] mx-auto px-4 sm:px-6 md:px-12 flex items-center gap-2 sm:gap-3"><Link href="/events" className="font-body text-[11px] tracking-[0.15em] uppercase text-[#DF6D2A] hover:text-[#0F1C2E] transition-colors flex items-center gap-2 shrink-0"><ArrowLeft size={14} /> Events</Link><span className="text-[#0F1C2E]/20">/</span><span className="font-body text-[11px] tracking-[0.1em] uppercase text-[#4C596B] truncate">Archival Retrospective</span></div></section>;
      $[16] = t2;
    } else {
      t2 = $[16];
    }
    let t9;
    if ($[17] !== event.category) {
      t9 = <span className="font-body text-[9px] tracking-[0.15em] uppercase px-2.5 py-1 bg-[#0F1C2E] text-[#F4EFE6]">{event.category}</span>;
      $[17] = event.category;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    let t10;
    if ($[19] !== event.region) {
      t10 = <span className="font-body text-[9px] tracking-[0.15em] uppercase px-2.5 py-1 border border-[#0F1C2E]/20 text-[#4C596B]">{event.region}</span>;
      $[19] = event.region;
      $[20] = t10;
    } else {
      t10 = $[20];
    }
    let t11;
    if ($[21] !== t10 || $[22] !== t9) {
      t11 = <div className="flex flex-wrap items-center gap-2 sm:gap-3 mb-5 sm:mb-6">{t9}{t10}</div>;
      $[21] = t10;
      $[22] = t9;
      $[23] = t11;
    } else {
      t11 = $[23];
    }
    let t12;
    if ($[24] !== event.title) {
      t12 = <h1 className="font-display text-[32px] sm:text-[44px] md:text-[52px] text-[#0F1C2E] leading-[1.05] mb-6 sm:mb-8">{event.title}</h1>;
      $[24] = event.title;
      $[25] = t12;
    } else {
      t12 = $[25];
    }
    let t13;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <Calendar size={16} className="text-[#C9A84C]" />;
      $[26] = t13;
    } else {
      t13 = $[26];
    }
    let t14;
    if ($[27] !== event.date) {
      t14 = <div className="flex items-center gap-2 text-[#4C596B]">{t13}<span className="font-body text-[13px] sm:text-[14px]">{event.date}</span></div>;
      $[27] = event.date;
      $[28] = t14;
    } else {
      t14 = $[28];
    }
    let t15;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <MapPin size={16} className="text-[#C9A84C]" />;
      $[29] = t15;
    } else {
      t15 = $[29];
    }
    let t16;
    if ($[30] !== event.location) {
      t16 = <div className="flex items-center gap-2 text-[#4C596B]">{t15}<span className="font-body text-[13px] sm:text-[14px]">{event.location}</span></div>;
      $[30] = event.location;
      $[31] = t16;
    } else {
      t16 = $[31];
    }
    let t17;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t17 = <Tag size={16} className="text-[#C9A84C]" />;
      $[32] = t17;
    } else {
      t17 = $[32];
    }
    let t18;
    if ($[33] !== event.category) {
      t18 = <div className="flex items-center gap-2 text-[#4C596B]">{t17}<span className="font-body text-[13px] sm:text-[14px]">{event.category}</span></div>;
      $[33] = event.category;
      $[34] = t18;
    } else {
      t18 = $[34];
    }
    let t19;
    if ($[35] !== t14 || $[36] !== t16 || $[37] !== t18) {
      t19 = <div className="flex flex-col sm:flex-row sm:flex-wrap gap-4 sm:gap-8 mb-8 sm:mb-12 pb-8 border-b border-[#0F1C2E]/10">{t14}{t16}{t18}</div>;
      $[35] = t14;
      $[36] = t16;
      $[37] = t18;
      $[38] = t19;
    } else {
      t19 = $[38];
    }
    let t20;
    if ($[39] !== event.description) {
      t20 = event.description.map(_temp);
      $[39] = event.description;
      $[40] = t20;
    } else {
      t20 = $[40];
    }
    let t21;
    if ($[41] !== t20) {
      t21 = <div className="prose-girmitiya space-y-5 sm:space-y-6 max-w-[720px] mb-4">{t20}</div>;
      $[41] = t20;
      $[42] = t21;
    } else {
      t21 = $[42];
    }
    const t22 = <EventGallery event={event} />;
    let t23;
    if ($[43] !== t22) {
      t23 = <div className="w-full">{t22}</div>;
      $[43] = t22;
      $[44] = t23;
    } else {
      t23 = $[44];
    }
    if ($[45] !== t11 || $[46] !== t12 || $[47] !== t19 || $[48] !== t21 || $[49] !== t23) {
      t3 = <section className="max-w-[1100px] mx-auto px-4 sm:px-6 md:px-12 py-10 sm:py-14 md:py-20">{t11}{t12}{t19}{t21}{t23}</section>;
      $[45] = t11;
      $[46] = t12;
      $[47] = t19;
      $[48] = t21;
      $[49] = t23;
      $[50] = t3;
    } else {
      t3 = $[50];
    }
    t4 = relatedEvents.length > 0 && <section className="bg-[#EBE5D9] border-t border-[#0F1C2E]/10 py-12 sm:py-16"><div className="max-w-[1100px] mx-auto px-4 sm:px-6 md:px-12"><h2 className="font-display text-[24px] sm:text-[32px] text-[#0F1C2E] mb-6 sm:mb-8">More from the <em className="text-[#C9A84C] italic">Archive</em></h2><div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">{relatedEvents.map(_temp2)}</div></div></section>;
    $[1] = event;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[51] !== t1 || $[52] !== t2 || $[53] !== t3 || $[54] !== t4) {
    t6 = <main className={t1}>{t2}{t3}{t4}</main>;
    $[51] = t1;
    $[52] = t2;
    $[53] = t3;
    $[54] = t4;
    $[55] = t6;
  } else {
    t6 = $[55];
  }
  let t7;
  if ($[56] !== t5 || $[57] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[56] = t5;
    $[57] = t6;
    $[58] = t7;
  } else {
    t7 = $[58];
  }
  return t7;
}
function _temp2(rel) {
  return <Link key={rel.slug} href={`/events/${rel.slug}`} className="group border border-[#0F1C2E]/10 bg-[#F4EFE6] hover:border-[#DF6D2A]/40 transition-colors overflow-hidden"><div className="aspect-square overflow-hidden"><EventCardMedia event={rel} /></div><div className="p-4"><p className="font-body text-[10px] uppercase tracking-[0.15em] text-[#DF6D2A] mb-1">{rel.date}</p><h3 className="font-display text-[18px] text-[#0F1C2E] group-hover:text-[#DF6D2A] transition-colors line-clamp-2">{rel.title}</h3></div></Link>;
}
function _temp(para, i) {
  return <p key={i} className="font-body text-[15px] sm:text-[16px] text-[#4C596B] leading-[1.75] sm:leading-[1.8]">{para}</p>;
}
export async function getStaticPaths() {
  return {
    paths: archivalEventsData.map(e => ({
      params: {
        slug: e.slug
      }
    })),
    fallback: false
  };
}
export async function getStaticProps({
  params
}) {
  const event = getArchivalEvent(params.slug);
  return {
    props: {
      event: event || null
    }
  };
}